import React from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
/* REDUX */
import { connect } from 'react-redux'
import { loadSaves, saveReport } from '../../actions/attributes'

class AttrSaved extends React.Component {
	constructor(props) {
		super(props)
		this.state = { 
			userSaved: false
		}
		this.handleSave = this.handleSave.bind(this)
	}
	
	componentWillMount() {
		this.setState({
			userSaved: this.props.userSaved
		})
	}
	
	componentWillReceiveProps(nextProps) {
		this.setState({
			userSaved: nextProps.userSaved
		})
	}
	
	handleSave(e) {
		e.preventDefault()
		const { authenticated, onLogin, saveReport, report_id } = this.props
		if (!authenticated) {
			onLogin()
			return
		}
		if (this.state.userSaved) {
			saveReport(report_id, 'unsave')
		} else {
			saveReport(report_id, 'save')
		}
	}
	
	render() {
		return (
			<button type="button" className={ this.state.userSaved ? "attr saved" : "attr" } onClick={ this.handleSave }><span className="icon"><svg viewBox="0 0 384 512"><path d="M336 0H48C21.49 0 0 21.49 0 48v464l192-112 192 112V48c0-26.51-21.49-48-48-48zm0 428.43l-144-84-144 84V54a6 6 0 0 1 6-6h276c3.314 0 6 2.683 6 5.996V428.43z"></path></svg></span><span className="label">{this.state.userSaved ? 'Saved' : 'Save' }</span></button>
		)
	}
}

const loadData = ({ report_id, loadLikes, loadSaves }) => {
	loadSaves(report_id)
}

class AttrSave extends React.Component {
	
	componentWillMount() {
		loadData(this.props)
	}
	
	componentWillReceiveProps(nextProps) {
		if (nextProps.report_id !== this.props.report_id) {
			loadData(nextProps)
		}
	}
	
	render() {
		
		const { report_id, saves, commentsCount, user_id, authenticated, onLogin, saveReport } = this.props
		
		if (!saves) {
			return <div></div>
		}
				
		const userSaved = saves.indexOf(user_id) > -1 ? true : false

		return (
			<div className="share ml-auto">
				<AttrSaved report_id={ report_id } userSaved={ userSaved } authenticated={ authenticated } onLogin={ onLogin } saveReport={ saveReport } />
				<a className="attr attr-hide fb-xfbml-parse-ignore" target="_blank" href={"https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Ftheflightpost.com%2Freport%2F"+report_id+"&amp;src=sdkpreparse"}><span className="icon"><svg viewBox="0 0 448 512"><path d="M448 416c0 53.019-42.981 96-96 96s-96-42.981-96-96a95.942 95.942 0 0 1 4.438-28.924l-98.337-61.46C144.887 341.966 121.616 352 96 352c-53.019 0-96-42.981-96-96s42.981-96 96-96c25.616 0 48.887 10.034 66.101 26.385l98.337-61.461A95.942 95.942 0 0 1 256 96c0-53.019 42.981-96 96-96s96 42.981 96 96-42.981 96-96 96c-25.616 0-48.887-10.034-66.101-26.385l-98.337 61.461c5.917 18.75 5.922 39.083 0 57.848l98.337 61.461C303.113 330.034 326.384 320 352 320c53.019 0 96 42.981 96 96zM352 48c-26.467 0-48 21.533-48 48s21.533 48 48 48 48-21.533 48-48-21.533-48-48-48M96 208c-26.467 0-48 21.533-48 48s21.533 48 48 48 48-21.533 48-48-21.533-48-48-48m256 160c-26.467 0-48 21.533-48 48s21.533 48 48 48 48-21.533 48-48-21.533-48-48-48"></path></svg></span><span className="label">Share</span></a>
			</div>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	const report_id = ownProps.report_id
	const {
		savesById
	} = state
	const savesWrapper = savesById[report_id] || {}
	const saves = savesWrapper.saves
	return {
		report_id: report_id,
		saves,
		authenticated: state.auth.authenticated,
		user_id: state.auth.user_id || 0
	}
}

export default withRouter(connect(mapStateToProps, { loadSaves, saveReport })(AttrSave))


// WEBPACK FOOTER //
// ./src/components/Report/AttrSave.js